// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a8564f44","337":"c8a09d90","453":"4062a2ce","667":"7b1ee01b"}[chunkId] + ".chunk.js";
};